import type { Au13RuleSet } from "./types.js";

// AU-13 CCS ruleset for FY2024-25 (8 July 2024 – 30 June 2025).
//
// Activity-test era (the test still applied for the whole of FY2024-25 — the
// 3 Day Guarantee did not arrive until 5 Jan 2026). Retained for backdated
// reclaims that resolve against the rules in force then.
//
// Figures transcribed VERBATIM from the DSS Family Assistance Guide
// (§1.1.A.70 applicable percentage, §3.5.3 rate caps) as archived within
// FY2024-25, and the Services Australia activity-test table.
export const fy2024_25: Au13RuleSet = {
  product: "AU13",
  fy: "2024-25",
  effectiveFrom: "2024-07-08",
  effectiveTo: "2025-06-30",
  periodKey: "2024-25",
  periodLabel: "FY2024-25 (activity-test era)",
  periodFrom: "2024-07-08",
  periodTo: "2025-06-30",
  sources: {
    percentage: "https://guides.dss.gov.au/family-assistance-guide/1/1/a/70",
    incomeThresholds: "https://guides.dss.gov.au/family-assistance-guide/1/1/i/70",
    rateCaps: "https://guides.dss.gov.au/family-assistance-guide/3/5/3",
    hours:
      "https://www.servicesaustralia.gov.au/activity-level-and-subsidised-hours-for-child-care-subsidy",
  },
  sourcesVerifiedAt: "2026-06-13",
  // §1.1.A.70: 90% up to $83,280, taper 1% per $5,000, 0% at $533,280.
  standardTaper: {
    maxPercent: 0.9,
    maxThreshold: 83_280,
    taperStep: 5_000,
    zeroThreshold: 533_280,
  },
  // §1.1.A.70 higher CCS for second-and-younger children: 95% up to $141,321,
  // taper $3,000 to 80% flat ($186,321–$265,611), taper $3,000 to 50% flat
  // ($355,611–$365,611), then standard rate at $365,611.
  higherRate: {
    topThreshold: 141_321,
    topPercent: 0.95,
    taperStep: 3_000,
    midPercent: 0.8,
    midFromThreshold: 186_321,
    midToThreshold: 265_611,
    floorPercent: 0.5,
    revertThreshold: 365_611,
  },
  // Activity test (Services Australia): activity hours/fortnight → subsidised
  // hours/fortnight. Families below the max-% income threshold who do < 8 hrs
  // get the 24-hr low-income safety net; above it, 0 hrs.
  hours: {
    mode: "activity_test",
    activityTiers: [
      { fromHours: 8, toHours: 16, subsidisedHours: 36 },
      { fromHours: 16, toHours: 48, subsidisedHours: 72 },
      { fromHours: 48, toHours: null, subsidisedHours: 100 },
    ],
    lowIncomeSafetyNetHours: 24,
    guaranteeHours: 0,
    highTierHours: 100,
    highTierActivityThreshold: 48,
    // Indigenous children: at least 36 hrs regardless of activity (this is the
    // floor; higher activity still lifts them up the standard tiers).
    indigenousHours: 36,
  },
  // §3.5.3 hourly rate caps, 2024-25 (effective 8 July 2024).
  rateCaps: {
    centreBasedBelowSchool: 14.29,
    centreBasedSchoolAged: 12.51,
    oshcBelowSchool: 14.29,
    oshcSchoolAged: 12.51,
    familyDayCare: 13.24,
    inHomeCarePerFamily: 38.87,
  },
};
